/**
 * Created by laslo on 6/23/20.
 */
import React, { useState, useEffect } from "react"
import './style.css'

const SearchInput = ({ onClick, onChange }) => {
  const [searchTerm, setSearchTerm] = useState('');

  const searchTermChanged = (e) => {
    e.preventDefault()
    setSearchTerm(e.target.value)
    if (onChange) onChange(e.target.value)
  }

  const onSearchAction = () => {
    if (onClick) onClick(searchTerm)
    setSearchTerm('')
  }

  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      onSearchAction()
    }
  }

  return (
    <div className="search-box">
      <input type="text" value={searchTerm} onKeyDown={handleKeyDown} onChange={searchTermChanged} />
      <i className="fa fa-search file-search" aria-hidden="true" onClick={onSearchAction}/>
    </div>)
}

export default SearchInput;


// WEBPACK FOOTER //
// ./src/components/searchInput/index.js